(function ($) {
  'use strict';

  if (!$ || !$('body').hasClass('product-magnesium-complex-newdesign')) {
    return;
  }

  /**
   * This template used to build a Recharge "bundle" SKU out of a separate
   * parent bundle product (1/3/6 month products picked in the section
   * settings) plus the current product as a child selection.
   *
   * The client now wants the same visual design, but selecting a quantity
   * option (1 / 3 / 6 bottles) should add THIS product's own variant
   * straight to the cart - no separate bundle product, no Recharge bundle
   * wrapping.
   *
   * IMPORTANT: unlike "magnesium-complex" (which has 3 real variants -
   * "1 Bottle" / "3 Bottles" / "6 Bottles"), the "magnesium-complex-bundle"
   * product only has ONE variant ("1 Bottle"). So there is no separate
   * variant to "select" for the 3 and 6 bottle tiers - instead we add that
   * same variant with quantity 3 or 6.
   *
   * To stay generic (in case a product using this template ever does have
   * distinct 1/3/6 variants, like magnesium-complex), each tier first looks
   * for a variant whose option matches its quantity; if none exists it
   * falls back to the product's base variant and multiplies the quantity
   * instead.
   */

  function pickVariantForQty(variants, qty) {
    var match = null;
    $.each(variants, function (i, v) {
      var n = String(v.option1 || v.title || '').match(/\d+/);
      if (n && Number(n[0]) === qty) {
        match = v;
        return false; // stop $.each
      }
    });
    return match;
  }

  function getBaseVariant(variants) {
    return pickVariantForQty(variants, 1) || variants[0];
  }

  function pickSellingPlanAllocation(variant, qty) {
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) {
      return null;
    }
    var idx = qty === 1 ? 0 : qty === 3 ? 1 : qty === 6 ? 2 : 0;
    return variant.selling_plan_allocations[idx] || variant.selling_plan_allocations[0];
  }

  /**
   * Resolves cart + pricing data for a given bottle-quantity tier (1, 3 or 6).
   */
  function buildTierData(variants, qty) {
    var ownVariant = pickVariantForQty(variants, qty);
    var variant = ownVariant || getBaseVariant(variants);
    if (!variant) {
      return null;
    }

    var allocation = pickSellingPlanAllocation(variant, qty);
    var divisor = ownVariant ? qty : 1;

    var unitOtpPrice = (variant.price / 100) / divisor;
    var unitSubPrice = allocation ? ((allocation.price / 100) / divisor) : unitOtpPrice;

    var totalOtpPrice = ownVariant ? (variant.price / 100) : (unitOtpPrice * qty);
    var totalSubPrice = ownVariant
      ? (allocation ? (allocation.price / 100) : totalOtpPrice)
      : (unitSubPrice * qty);

    return {
      variantId: variant.id,
      quantity: ownVariant ? 1 : qty,
      sellingPlanId: allocation ? allocation.selling_plan_id : null,
      unitOtpPrice: unitOtpPrice.toFixed(2),
      unitSubPrice: unitSubPrice.toFixed(2),
      totalOtpPrice: totalOtpPrice.toFixed(2),
      totalSubPrice: totalSubPrice.toFixed(2)
    };
  }

  /** Reads this product's own variants and wires them onto the op1/op2/op3 quantity cards. **/
  function refreshVariantData() {
    var od_variantdata = $('.oddit_product').first().data('productvariants');

    if (!od_variantdata || !od_variantdata.length) {
      return;
    }

    var $offers = {
      op1: $('.new_buyboxlayout .offer-part.op1').first(),
      op2: $('.new_buyboxlayout .offer-part.op2').first(),
      op3: $('.new_buyboxlayout .offer-part.op3').first()
    };

    $.each($offers, function (key, $offer) {
      if (!$offer.length) {
        return;
      }

      var relQty = Number($offer.attr('rel'));
      if (!relQty) {
        var labelMatch = String($offer.find('.title_bld').text() || '').match(/\d+/);
        relQty = labelMatch ? Number(labelMatch[0]) : 1;
      }

      var tier = buildTierData(od_variantdata, relQty);
      if (!tier) {
        return;
      }

      $offer.data('bottleQty', relQty);
      $offer.data('cartQty', tier.quantity);
      $offer.data('variantId', tier.variantId);
      $offer.data('sellingPlanId', tier.sellingPlanId);
      $offer.data('unitOtpPrice', tier.unitOtpPrice);
      $offer.data('unitSubPrice', tier.unitSubPrice);
      $offer.data('totalOtpPrice', tier.totalOtpPrice);
      $offer.data('totalSubPrice', tier.totalSubPrice);

      $offer.attr('data-variationid', tier.variantId);
      $offer.attr('data-sellingplan', tier.sellingPlanId || '');
    });
  }

  const urlParams = new URLSearchParams(window.location.search);
  const purchaseOption = urlParams.get('purchaseoption');

  try {
    refreshVariantData();
  } catch (e) {
    console.error('Magnesium bundle: failed to read product variant data.', e);
  }

  if (purchaseOption === 'onetime') {
    $('.offer-part').removeClass('active');
    $('.offer-part.op3')
      .addClass('active')
      .trigger('click');
    $('.tb').removeClass('active');
    $('.tb.oneio').addClass('active')
      .trigger('click');
  } else {
    $('.offer-part').removeClass('active');
    $('.offer-part.op3')
      .addClass('active')
      .trigger('click');
  }

  function refreshRechargeCart() {
    if (typeof window.ReChargeCartUpdate === 'function') {
      window.ReChargeCartUpdate();
    } else if (window.RECHARGE_CART && typeof window.RECHARGE_CART.updateCart === 'function') {
      window.RECHARGE_CART.updateCart();
    }
  }

  function updatePrices() {
    var $activeOffer = $('.new_buyboxlayout .offer-part.active').first();
    var isSubscription = $('.new_buyboxlayout .tb.active').attr('rel') === 'subscription';

    // Per-card "£x.xx / bottle" price, based on this product's real variant price.
    $('.new_buyboxlayout .offer-part').each(function () {
      var $card = $(this);
      var unitPrice = isSubscription ? $card.data('unitSubPrice') : $card.data('unitOtpPrice');
      if (unitPrice) {
        $card.find('.top_last_insupp').text('£' + unitPrice + ' / bottle');
      }
    });

    if ($activeOffer.length) {
      var totalOtp = $activeOffer.data('totalOtpPrice');
      var totalSub = $activeOffer.data('totalSubPrice');

      if (totalOtp) {
        $('.otp_each_price').text('£' + totalOtp);
        $('.otp_cross_price').text('');
      }
      if (totalSub) {
        $('.sub_each_price').text('£' + totalSub);
        $('.sub_cross_price').text(totalOtp ? '£' + totalOtp : '');
      }

      var totalPrice = isSubscription ? totalSub : totalOtp;
      if (totalPrice) {
        $('.add_to_cart .totalprice').text('£' + totalPrice);
      }
    }

    $('.add_to_cart .dd').text('Add to Cart');
    $('.add_to_cart').attr('rel', isSubscription ? 'subscription' : 'onetime');
  }

  function initialiseGallery() {
    const $thumbs = $('#thumbnails .thumb');
    const $mainImage = $('#mainImage');
    let currentIndex = Math.max(0, $thumbs.index($thumbs.filter('.active').first()));

    function showImage(index) {
      if (!$thumbs.length) {
        return;
      }

      currentIndex = (index + $thumbs.length) % $thumbs.length;
      const $thumb = $thumbs.eq(currentIndex);
      const imageUrl = $thumb.find('img').attr('src');

      $thumbs.removeClass('active');
      $thumb.addClass('active');
      if (imageUrl) {
        $mainImage.attr('src', imageUrl);
      }
    }

    $thumbs.on('click', function () {
      showImage($thumbs.index(this));
    });
    $('#prevBtn').on('click', function (event) {
      event.preventDefault();
      showImage(currentIndex - 1);
    });
    $('#nextBtn').on('click', function (event) {
      event.preventDefault();
      showImage(currentIndex + 1);
    });
  }

  $(function () {
    initialiseGallery();
    updatePrices();
  });

  $(document).on('click', '.new_buyboxlayout .offer-part', function (event) {
    event.preventDefault();
    $('.new_buyboxlayout .offer-part').removeClass('active');
    $(this).addClass('active');
    updatePrices();
  });

  $(document).on('click', '.new_buyboxlayout .tb', function (event) {
    event.preventDefault();
    $('.new_buyboxlayout .tb').removeClass('active');
    $(this).addClass('active');
    updatePrices();
  });

  $(document).on('click', '.new_buyboxlayout .acc_bt', function () {
    const $item = $(this).closest('.acc_item');
    $item.toggleClass('active');
    $item.find('.acc_cnt').first().stop(true, true).slideToggle(200);
  });

  /**
   * Add to cart: adds the selected variant of THIS product directly to the
   * cart - quantity 1, 3 or 6 depending on the tier (or a distinct variant
   * with quantity 1 if the product actually has separate 1/3/6 variants),
   * plus the matching selling plan when subscribing. No bundle product, no
   * Recharge bundle API call.
   */
  $(document).on('click', '.add_to_cart', function (event) {
    event.preventDefault();

    const $button = $(this);
    if ($button.hasClass('disable') || $button.hasClass('disabled')) {
      return;
    }

    const $offer = $('.new_buyboxlayout .offer-part.active').first();
    const variantId = $offer.data('variantId');
    const cartQty = $offer.data('cartQty') || 1;
    const sellingPlanId = $offer.data('sellingPlanId');
    const purchasetype = $button.attr('rel');

    if (!variantId) {
      console.error('Magnesium bundle: no variant is selected.');
      alert('Please choose a quantity before adding to cart.');
      return;
    }

    var payloaddata = { quantity: cartQty, id: variantId, properties: {} };
    if (purchasetype === 'subscription') {
      if (!sellingPlanId) {
        alert('The subscription option is not available for this quantity.');
        return;
      }
      payloaddata.selling_plan = sellingPlanId;
    }

    $button.addClass('disabled');
    $('#loader-overlay').show();

    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: payloaddata
    })
      .done(function () {
        refreshRechargeCart();
      })
      .fail(function (res) {
        console.error('Unable to add product to cart:', res);
        alert('Something went wrong while adding the product. Please try again.');
      })
      .always(function () {
        $('#loader-overlay').hide();
        $button.removeClass('disabled');
      });
  });
})(window.jQuery);